import * as Sentry from "@sentry/browser";
import React from "react";
/**
 * ErrorBoundary component
 *
 * @see https://reactjs.org/docs/error-boundaries.html
 */
class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            error: null,
            eventId: null,
        };
    }
    static getDerivedStateFromError(error) {
        // Update state so the next render will show the fallback UI.
        return {
            error,
        };
    }
    componentDidCatch(error, errorInfo) {
        const { shouldReportToSentry } = this.props;
        // Check if client is initialised
        if (shouldReportToSentry && Sentry.getCurrentHub().getClient()) {
            Sentry.configureScope((scope) => {
                scope.setExtra("componentStack", errorInfo.componentStack);
            });
            const eventId = Sentry.captureException(error);
            this.setState({ eventId });
        }
    }
    render() {
        const { children, isTransparent } = this.props;
        const { error } = this.state;
        // NOTE: isTransparent is false by default, meaning the component would still render its throwing children.
        if (error && isTransparent) {
            return null;
        }
        return children;
    }
}
ErrorBoundary.defaultProps = {
    isTransparent: false,
    shouldReportToSentry: true,
};
export default ErrorBoundary;
